import endpoints from 'helper/endpoints'
import {fireErrorToast, fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_AREA_OF_WORK_FAIL,
  GET_AREA_OF_WORK_LIST_FAIL,
  GET_AREA_OF_WORK_LIST_REQUEST,
  GET_AREA_OF_WORK_LIST_SUCCESS,
  GET_AREA_OF_WORK_REQUEST,
  GET_AREA_OF_WORK_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getAreaOfWorkList = (limit = 1000, offset = 0, meta, search) => {
  return (dispatch) => {
    dispatch({type: GET_AREA_OF_WORK_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.areasOfWork + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
      })
      .then((res) => {
        dispatch({type: GET_AREA_OF_WORK_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_AREA_OF_WORK_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getAreaOfWork = (id) => {
  return (dispatch) => {
    dispatch({type: GET_AREA_OF_WORK_REQUEST})
    return httpClient
      .get(endpoints.areasOfWork + '/' + id)
      .then((res) => {
        dispatch({type: GET_AREA_OF_WORK_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_AREA_OF_WORK_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createAreaOfWork = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.areasOfWork, data)
      .then((res) => {
        fireSuccessToast(<Trans>New area of work created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchAreaOfWork = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.areasOfWork + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Area of work updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
